module.exports = __webpack_public_path__ + "img/12_l_uk.993412e9.svg";